import { createApp } from 'vue'
import App from './App.vue'
import store from "./store";
import VueGtag from "vue-gtag";
import clientConfig from '/src/config/client.mjs';
import LifetimeIframeControl from '/src/config/LifetimeIframeControl.js'

createApp(App)
 .use(store)
  .use(VueGtag, {
    appName: 'Insurance',
    pageTrackerScreenviewEnabled: true,
    config: {
      id: clientConfig.analytics.gacode,
      cookie_prefix: 'iq',
      cookie_flags: 'SameSite=None;Secure',
      params: {
        send_page_view: false,
        debug_mode: false
      }
    }
  })  
  .use(LifetimeIframeControl, {
    divId: "iqApp",
    clientConfig: clientConfig
  })
  .mount('#iqApp');